// components
import { Alert } from '@interstate/components/Alert';
import { Typography } from '@interstate/components/Typography';

// styling
import { StyledAlertWrapper } from './TableGlobalAlerts.style';

// types
import type { TableGlobalAlertInputProps } from '../../types';

const TableGlobalAlertInfo = ({ message, name }: TableGlobalAlertInputProps) => {
    return (
        <StyledAlertWrapper data-testid={`${name}-info-alert`}>
            <Alert role="banner" type="info">
                <Typography variant="label-md">{message}</Typography>
            </Alert>
        </StyledAlertWrapper>
    );
};

export default TableGlobalAlertInfo;
